import React from "react";

import { CodeEditor } from "src/base-components/CodeInput/CodeEditor";
import {
  FloatingWindowInternal,
  useFloatingWindowPosition,
} from "src/base-components/FloatingWindow/FloatingWindow";
import { useFloatingWindowsActions } from "src/base-components/FloatingWindow/hooks";
import { FloatingWindowProps } from "src/base-components/FloatingWindow/store";

type ToolCallContentWindowData = {
  title: string;
  content: string;
};

export const ToolCallContentWindow: React.FC<FloatingWindowProps> = ({
  computePosition,
  id,
  data,
}) => {
  const { close: closeWindow } = useFloatingWindowsActions();
  const { position, windowRef } = useFloatingWindowPosition(computePosition);

  const typedData = data as ToolCallContentWindowData;

  return (
    <FloatingWindowInternal
      ref={windowRef}
      height="h-120"
      id={id}
      style={{
        inset: "0px auto auto 0px",
        transform: position,
      }}
      title={typedData.title}
      width="w-160"
      draggable
      isMaximized
      isPinned
      maximizable
      resizeable
      onClose={() => closeWindow(id)}
    >
      <div className="h-full p-2">
        <CodeEditor
          language="json"
          value={typedData.content}
          disabled
          readOnly
        />
      </div>
    </FloatingWindowInternal>
  );
};
